<template lang='pug'>
  blue-layout( v-if='user' :user='user' :account='account' :biz='biz' )
    template(v-slot:header)
      bf-header(title='Verify Email')
    #verify-email.view( v-if='!updating && user' )
      h3 {{$t("Please go to your email")}}
      h1.email {{ user.email }}
      h3 {{$t("to verify your account")}}
      bf-divider.section
      h3 {{$t("If you did not receive the verification email in 30 minutes")}}
      h3
        resend-verification-button( v-if='user' :user='user' ) {{$t("Resend Verification")}}
      
      p.update-link.actionable( @click='updating = true' ) {{$t("Need to update your email?  Click here!")}}
    
    #verify-email.view( v-else )
      update-email-form( 
        v-if='user && account' 
        :user='user' 
        :account='account' 
        @back='updating = false' 
        @updated='updated'
      )
</template>

<script>
  import { auth } from '@/main'
  import { View } from '@/mixins/view'
  import UpdateEmailForm from '@/components/forms/update-email'
  import ResendVerificationButton from '@/components/buttons/resend-verification'
  
  export default {
    name: 'verify-email.view',
    
    mixins: [ View ],

    components: {
      UpdateEmailForm,
      ResendVerificationButton
    },

    data() {
      return {
        updating: false
      }
    },

    watch: {
      user( curr, prev ) {
        if ( curr ) this.observe()
      }
    },

    methods: {
      updated() {
        this.updating = false
      },

      observe() {
        if ( auth.currentUser ) this.interval = setInterval( () => auth.currentUser.reload().then( ok => {
          if ( auth.currentUser.emailVerified ) {
            this.$router.push({ name: 'welcome', params: { modals: 'to-bluefaucet' } })
          }
        }).catch( e => console.log(e) ), 1000)
      }
    },

    created() {
      if ( auth.currentUser && auth.currentUser.emailVerified ) this.$router.push({ name: 'welcome', params: { modals: 'to-bluefaucet' } })
      else this.observe()
    },

    beforeDestroy() {
      clearInterval( this.interval )
    }
  }

</script>

<style lang="stylus" scoped>
  #verify-email.view
    display flex
    align-items center
    flex-direction column
    padding 30px 32px

  .email
    margin 32px 0
    color red
  
  .update-link
    color var(--clr-blue)
    margin-top 64px
    font-size 1.2em

  button
    background var(--clr-blue)
    color white
    padding .5em 2em
    border-radius 5px
    margin-top 32px
    text-align center
</style>
